import { h, Component, ComponentChildren } from 'preact'
import Portal from 'preact-portal'
import Icon from '../../assets'

export type MessageTypes = 'success' | 'warning' | 'error'

interface Props {
  variant?: MessageTypes
  children?: ComponentChildren
  onDismiss: () => void
  isControl?: boolean
  hideIcon?: boolean
  timer?: number
  renderHTML?: boolean
  message?: string | null
}

type IconType = 'answer' | 'forbidden' | 'warning'
type MessageVariantIconTypeMap = Record<MessageTypes, IconType>
const variantTypeToIconTypeMapping: MessageVariantIconTypeMap = {
  success: 'answer',
  warning: 'warning',
  error: 'forbidden'
}

class Message extends Component<Props> {
  rootElement: Element | null = null
  timeoutHandle: number = 0

  constructor () {
    super()
    if (typeof window === 'undefined') return
    const root = document.querySelector('#message-container')
    if (root) {
      this.rootElement = root
      return
    }

    this.rootElement = document.createElement('div')
    this.rootElement.id = 'message-container'
    this.rootElement.className = 'a-message-container'
    document.body.appendChild(this.rootElement)
  }

  componentDidMount () {
    if (this.props.timer) {
      this.timeoutHandle = window.setTimeout(() => this.props.onDismiss(), this.props.timer)
    }
  }

  render () {
    const {
      variant = 'success',
      children,
      onDismiss,
      isControl = false,
      hideIcon = false,
      renderHTML = false,
      message
    } = this.props
    if (this.rootElement === null) {
      return null
    }
    return (
      <Portal into={this.rootElement as HTMLElement}>
        <section
          className={`a-message a-message--variant-${variant} ${isControl ? `a-message--insided-${variant}` : ''}`}
        >
          {
          !hideIcon && (
            <div className={`a-message--icon a-type-icon a-icon-${variant}`}>
              <Icon icon={variantTypeToIconTypeMapping[variant]} width={20} height={20} />
            </div>
          )
          }
          {
            Array(children).toString() !== ''
              ? <div className='a-message--text'>{children}</div>
              : (
                <div className='a-message--text-html' dangerouslySetInnerHTML={renderHTML && message ? { __html: message } : undefined}>
                  {message}
                </div>
              )
          }
          <div
            onClick={() => { window.clearTimeout(this.timeoutHandle); onDismiss() }}
            className='a-message--icon a-icon-close'
          ><Icon icon='close' width={20} height={20} /></div>
        </section>
      </Portal>
    )
  }
}

export default Message
